import React from 'react'

interface OTPHeaderProps {
  phoneNumber: string
  emailId: string
}

export const OTPHeader: React.FC<OTPHeaderProps> = ({ phoneNumber, emailId }) => {
  return (
    <div className='text-left pb-6 flex flex-col'>
      <div className='text-[22px] text-[#232323] font-[500] leading-[130%] pb-1'>Enter OTP</div>
      <div className='text-[14px] text-[#6A6E6E] font-[400] leading-[150%]'>
        Sent{' '}
        {(() => {
          if (phoneNumber && emailId) {
            return (
              <>
                to +91 {phoneNumber} and <br /> {emailId}
              </>
            )
          } else if (phoneNumber) {
            return `to +91 ${phoneNumber}`
          } else if (emailId) {
            return `to ${emailId}`
          } else {
            return ''
          }
        })()}
      </div>
    </div>
  )
}
